<app-smart-diagnosis type="Diseases"></app-smart-diagnosis>
